<template lang="pug">
div
    div(:class="`${jarvisForbidden || jarvisUnavailable ? 'mt-7' : 'mt-13'} mb-13`")
        p(class="text-h6") Enabling organizations to manage activist risks and maintain their social license to operate.
    div(class="mt-3")

        div(v-if="jarvisForbidden || jarvisUnavailable" style="color: red").mt-n10.mb-4
          div(v-if="jarvisForbidden")
            span You do not have access to Jarvis. Please contact
            a(href="mailto:chris@foresightreports.com" style="color: red" class="ml-1") chris@foresightreports.com

          div(v-if="jarvisUnavailable")
            span Apologies, but Jarvis is not available at the moment. Please try again later. If this issue persists, please contact
            a(href="mailto:chris@foresightreports.com" style="color: red" class="ml-1") chris@foresightreports.com

        MsalSignInButton(@click="login" :loading="authProccessing" color="primary" buttonText="Sign in with Microsoft")
        div(v-if="registrationLink" class="text-center mt-3")
            span() New to Jarvis? 
            span.ml-1
                a(:href="registrationLink") Register Here 
</template>

<script>
import MsalSignInButton from "@/components/msalSignInButton.vue";
import {
  MESSAGE_KEY_JARVIS_UNAVAILABLE,
  MESSAGE_KEY_NO_JARVIS_ACCESS,
} from "@/services/vue-apollo";
import { getRegistrationLink } from "../auth/vue-msal/msal-config";
import { login } from "../auth/vue-msal/service";
import { mapState } from "vuex";

export default {
  components: {
    MsalSignInButton,
  },
  data() {
    return {
      jarvisUnavailable: false,
      jarvisForbidden: false,
    };
  },
  methods: {
    async login() {
      this.jarvisUnavailable = false;
      this.jarvisForbidden = false;
      await login();
      this.$router.push("/dashboard");
    },
  },
  mounted() {
    const jarvisForbidden = localStorage.getItem(MESSAGE_KEY_NO_JARVIS_ACCESS);
    const jarvisUnavailable = localStorage.getItem(
      MESSAGE_KEY_JARVIS_UNAVAILABLE
    );
    if (jarvisForbidden === "true") {
      this.jarvisForbidden = true;
    }
    if (jarvisUnavailable === "true") {
      this.jarvisUnavailable = true;
    }
    localStorage.removeItem(MESSAGE_KEY_NO_JARVIS_ACCESS);
    localStorage.removeItem(MESSAGE_KEY_JARVIS_UNAVAILABLE);
  },
  computed: {
    ...mapState("auth", ["loginStarted"]),
    registrationLink() {
      return getRegistrationLink();
    },
    fetchingUserContext() {
      return this.$store.state.fetchingUser;
    },
    authProccessing() {
      return this.loginStarted || this.fetchingUserContext;
    },
  },
};
</script>
../auth/vue-msal/msal-config
